export default {"src":"/_next/static/media/mussels.e02fbab3.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};